module.exports = __webpack_public_path__ + "img/skv_ikit_claw_0.28240dc4.png";